import { Reveal } from '../components/motion';
import SEO from '../components/SEO';
import { SectionTag, ArrowBtn, PageHero, ChainFlow } from '../components/bits';
import { useLead } from '../components/LeadModal';

const REACH = ['Audience research', 'Content strategy', 'Campaign execution', 'Creator network', 'Digital distribution', 'Performance optimisation'];
const RESPONSE = ['Digital monitoring', 'Rapid response', 'Reputation support', 'Issue management', 'Real-time intelligence'];

export default function MarketingCell() {
  const { open } = useLead();
  return (
    <div data-testid="marketing-cell-page">
    <SEO title="Marketing Cell" description="Digital reach backed by intelligence — research, campaigns, distribution and rapid response." />
      <PageHero
        ck="marketing"
        tag="Marketing Cell"
        lines={<>Digital Reach Backed by <span className="font-serif italic font-normal text-electric">Intelligence.</span></>}
        intro="The Marketing Cell combines audience development, content, campaign execution and digital monitoring with the wider DITEC ecosystem."
      >
        <ArrowBtn onClick={() => open('Marketing Cell')} variant="primary" testId="mc-cta-explore">Explore Marketing Cell</ArrowBtn>
      </PageHero>

      <section className="bg-paper py-20 sm:py-28">
        <div className="wrap grid gap-6 lg:grid-cols-2">
          <Reveal className="rounded-3xl bg-navy p-8 text-white sm:p-12">
            <span className="overline !text-[10px] text-gold">Active Reach</span>
            <ul className="mt-8 grid gap-3 sm:grid-cols-2">
              {REACH.map((r) => (
                <li key={r} className="flex items-center gap-2.5 rounded-xl bg-navy-800/80 px-4 py-3 text-sm font-medium text-white/85">
                  <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />{r}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.1} className="rounded-3xl border border-navy/10 bg-white p-8 sm:p-12">
            <span className="overline !text-[10px] text-electric">Active Response</span>
            <ul className="mt-8 grid gap-3 sm:grid-cols-2">
              {RESPONSE.map((r) => (
                <li key={r} className="flex items-center gap-2.5 rounded-xl bg-paper px-4 py-3 text-sm font-medium text-navy/85">
                  <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-electric" />{r}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-20 sm:py-28">
        <div className="wrap">
          <SectionTag>How It Works</SectionTag>
          <Reveal delay={0.08} className="mt-10">
            <ChainFlow steps={['Research', 'Audience Intelligence', 'Strategy', 'Content', 'Distribution', 'Measurement', 'Optimisation']} testId="mc-flow" />
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-8 max-w-3xl text-base leading-relaxed text-navy/70 sm:text-lg">
              The Marketing Cell can use the wider alumni and digital ecosystem as a distributed communication capability.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-8"><ArrowBtn onClick={() => open('Marketing Cell')} variant="navy" testId="mc-cta-bottom">Explore Marketing Cell</ArrowBtn></Reveal>
        </div>
      </section>
    </div>
  );
}
